// export const BASE_URL="http://localhost:8000/v1";     
// export const BASE_URL="http://54.90.21.249:8000/v1";     
// export const BASE_URL="http://localhost:8000/v1";     
// export const BASE_URL="http://50.17.107.208:3004/v1"; 
export const BASE_URL="https://backend.secuber.io/v1";     
export const RED="red";
export const GREY="grey";
     